import apiUrl from "../../../constants";
import awsBucketName from "../../../constants";
import axios from "axios";
import CryptoJS from "crypto-js";
import { Validator } from "vee-validate";
import VueElementLoading from "vue-element-loading";
import { BasicSelect } from "vue-search-select";
import Paginate from "vuejs-paginate";
import moment from "moment";
import PageTracker from "../../../common/PageTrackerHelper";



export default {
  components: {
    Paginate,
    VueElementLoading,
    BasicSelect,
  },
  mixins: [PageTracker],
  data() {
    return {
      awbNumber: "",
      key: 0,
      regionName: "",
      hubzonename: "",
      currentHubName: "",
      destinationHubName: "",
      bagCondition: "",
      DEPSbagcondition: "",
      OctroiMRP: "",
      Clientname: "",
      productDescription: "",
      STDreason: "",
      description: "",
      hubOrigin: "",
      Currenthub: "",
      Destinationhub: "",
      lastService: "",
      currentRegion: "",
      editshowtable: false,
      HubZoneId: "",
      newhubList: [],
      ids: "",
      vStatusList: [
        {text: "Intact"},
        {text: "Torn/Damage"},
        {text: "WithoutSeal"},
        ],
        DEPSbagcondition: {
          text: ""
        },
        stdreason: {
          text: ""
        },
      // vStatusList:["Intact","Torn/Damage","WithoutSeal"],
     
      StatusList: [
        {text: "Liquid Spillage", },
        {text: "Poor Packaging",},
        {text: "Improper Handling",},
        {text: "Accidental Damage",},
        {text: "Fragile Items",},
        {text: "Damage due to Rain",},
        {text: "Natural Calamity",},
        {text :"Pilferage",},
      ],
      hubdroplist: [],
      myStr: "",
      shipmenarr: [],
      hubList: [],
      attachment: null,
      displaytable: false,
      imagesarr: [],
      image: "",
      imgdata: "",
      showModal: false,
      originHubName: "",
      imgData: "",
    };
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem("userUniqueKey");
    var userdetailEncrypt = window.localStorage.getItem("lmaccessuserdata");
    var bytes = CryptoJS.AES.decrypt(
      userdetailEncrypt.toString(),
      this.userDataKey
    );
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.useremail = userdetail.email;
    this.username = userdetail.username;
    this.hubId = userdetail.hubdetails[0];
  },
  methods: {
    resetForm() {
      this.imagesarr = [];
      this.awbNumber = "";
      this.regionName = "";
      this.hubzonename = "";
      this.currentHubName = "";
      this.destinationHubName = "";
      this.bagCondition = "";
      this.DEPSbagcondition = "";
      this.OctroiMRP = "";
      this.Clientname = "";
      this.productDescription = "";
      this.STDreason = "";
      this.description = "";
      this.originHubName = "";
      this.Currenthub = "";
      this.Destinationhub = "";
      this.lastService = "";
      this.currentRegion = "";
      this.$validator.reset();
      this.errors.clear();
      this.key += 1;
      this.$refs.fileInput.value = "";
      this.stdreason="",
      this.DEPSbagcondition=""
    },
    async searchAwbNumber(awbNumber) {
      if (!awbNumber) {
        this.$alertify.error("Please enter a valid AWB number.");
        return;
      }

      const input = {
        ShippingID: awbNumber,
      };

      try {
        const result = await axios.post(
          `${apiUrl.api_url}Investigationsearchawb`,
          input
        );

        console.log("API Response:", result.data);

        if (result.data.code === 200) {
          this.shipmetdetails = result.data.data;

          if (this.shipmenarr) {
            this.OctroiMRP = this.shipmetdetails.OctroiMRP || "";
            this.Clientname = this.shipmetdetails.ClientName || "";
            this.productDescription = this.shipmetdetails.ProductDesc || "";
            this.description = this.shipmetdetails.Description || "";
            this.bagCondition = this.shipmetdetails.BagCondition || "";
            this.STDreason = this.shipmetdetails.STDReason || "";
            this.hubzonename = this.shipmetdetails.HubzoneName || "";
            this.currentHubName = this.shipmetdetails.currentHubName || "";
            this.originHubName = this.shipmetdetails.originHubName || "";
            this.destinationHubName = this.shipmetdetails.destinationHubName || "";
            this.HubZoneId = this.shipmetdetails.HunZoneID;
          }

          this.editshowtable = false;
          try {
            let TrackerInfo = {
              projectname: "Last Mile",
              type: "Web",
              routeurl: "Investigationsearchawb",
              userid: this.localuserid,
              username: this.username,
              meta: {
                event: "Investigationsearchawb",
                shipmentId: input ? (input.ShippingID ? input.ShippingID : null) : null,
                remarks: "FrontEnd",
                hubId: this.hubId ? this.hubId : null,
              },
            };
            this.PageTracker(TrackerInfo);
          } catch (error) {
            console.log(error);
          }
        } else {
          const message = result.data.message || "No data found";
          this.$alertify.error(message);
        }
      } catch (error) {
        console.error("Error occurred while searching AWB:", error);

        this.$alertify.error(
          error.response.data.message ||
            "Unable to search AWB. Please try again later."
        );
      }
    },
    
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onFileChange(event) {
      const files = event.target.files;
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
      const maxFileSize = 600 * 1024;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (!allowedTypes.includes(file.type)) {
          this.$alertify.error(`Invalid file type: ${file.name}`);
          continue;
        }

        if (file.size > maxFileSize) {
          this.$alertify.error(`File size exceeds 600KB: ${file.name}`);
          continue;
        }
        this.imagesarr.push({
          file: file.name,
          attachment: file,
          preview: URL.createObjectURL(file),
        });
        if (this.imagesarr.length > 3) {
          this.imagesarr.pop();
          this.$alertify.error("You can only upload up to 3 images.");
        }
      }
      event.target.value = "";
    },
  

    async uploadFile() {
      if (!this.awbNumber) {
        this.$alertify.error("Please enter Shipping ID/AWB Number");
        return;
      }
      // if (this.imagesarr.length === 0) {
      //   this.$alertify.error("Please select images to upload.");
      //   return;
      // }
      const formData = new FormData();
      this.imagesarr.forEach((image) => {
        formData.append("files", image.attachment);
      });
      formData.append("shippingID", this.awbNumber);
      try {
        const result = await axios.post(
          apiUrl.api_url + "uploadimage",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (result.status === 200 && result.data.code === 200) {
          this.$alertify.success("Images uploaded successfully.");
          
        } else {
          this.$alertify.error("Failed to upload images.");
        }
      } catch (error) {
        this.$alertify.error("An error occurred while uploading images.");
      }
    },
    viewImage(preview) {
      this.imgData = preview;
      this.showModal = true;
    },
    deleteImage(index) {
      this.imagesarr.splice(index, 1);
          this.$alertify.success("Image deleted successfully.");
    },
    
    closeImage() {
      this.imgData = "";
      this.showModal = false;
    },
    updatedata() {
      if(!this.awbNumber){
        this.$alertify.error("Please enter AWB number.");
        
      }
      
      else if (!this.DEPSbagcondition.text) {
        this.$alertify.error("Please select DEPS Bag Condition.");
        
      }
      else if (!this.stdreason.text) {
        this.$alertify.error("Please select STD Reason.");
        
      }
    
      else if (this.imagesarr.length<=2 && this.OctroiMRP >1000) {
        console.log("+++",this.imagesarr.length);
        this.$alertify.error("Please upload three images.");
        
      }
      else if (!this.description) {
        this.$alertify.error("Please fill description.");
       
      }
      else{
      const currentdate = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");
      const FinanceLoggeddate = moment(new Date()).format(
        "YYYY-MM-DD HH:mm:ss.SSS"
      );
      const hubzoneid = this.shipmetdetails["HubZoneID"];
      const currenthubid = this.shipmetdetails["CurrentHubID"];
      const input = {
        ShippingID: this.awbNumber,
        CurrentHubID: currenthubid.toString(),
        ShipmentVerifiedAs: this.username,
        Status: "1",
        STDbagcondition: this.DEPSbagcondition.text,
        StatusMarkedFrom: "Web",
        Comments: this.description,
        LastModifiedBy: this.username,
        LastModifiedDate: currentdate,
        FinanceLoggeddate: FinanceLoggeddate,
        BucketTypeCode: 4,
        HubZoneID: hubzoneid.toString(),
      };
      axios({
        method: 'post',
        url: apiUrl.api_url + 'AddToInvestigation',
        data: input,
       
    }).then(result => {
      
      
        if (result.data.code === 200) {
            this.$alertify.success(result.data.message)
            this.resetForm();
        }
        else {
            this.$alertify.error(result.data.message)
        }
    })  
}
},

  selectstdreason(stdreason) {
      this.stdreason =stdreason;  
},
selectDEPSbagcondition(DEPSbagcondition) {
    this.DEPSbagcondition = DEPSbagcondition;
},
}

};


// WEBPACK FOOTER //
// ./src/views/components/STDdamaged/stddamaged.component.js